import React from 'react';
import aim from "../about-images/about02.jpg"
import atma from "../global-images/vector-about.png"
import atma2 from "../about-images/atmanirbhar.jpg"
import mission from '../about-images/mission3.png';
const About = () => {
    // Replace this with actual inView state from react-intersection-observer

    return (
        <div className="flex flex-col justify-center items-center w-full p-10 bg-white rounded-lg shadow-lg">
            <div className="w-full mt-20 bg-white rounded-3xl">
                {/* <div className="text-center text-black  ">
                    <motion.h1
                        className="text-4xl font-bold italic text-blue-600"
                        transition={{ duration: 1, repeat: Infinity }}
                    >
                        About Us
                    </motion.h1>
                </div> */}
                <div className='w-full flex grid lg:grid-cols-2 md:grid-cols-1 '>
                    {/* <div className=''></div> */}
                    <div className='font-montserrat  text-start flex grid grid-cols-1'>
                        <h1 className='text-black p-10 lg:text-center text-5xl font-bold'><span className='text-7xl text-blue-600'>A</span>bout Us</h1>
                        <div className='lg:ml-15 lg:text-lg p-12 '>
                            <span className='text-2xl text-blue-500'>W</span>ith the aim of building a robust startup ecosystem within the state and beyond, IIT Ropar
                            Technology Business Incubator Foundation (TBIF) strives to nurture and create value for
                            startups, MSMEs, entrepreneurs, and other ecosystem partners. Its mission is to enable and
                            empower an ecosystem hungry for innovation. IIT Ropar - TBIF, which was established in 2016
                            as a Section 8 company (non-profit organization), offers startups a 20,000 sq. ft. incubation
                            facility to help start, scale up, and accelerate. It is set up under the NIDHI TBI Scheme of the
                            Department of Science and Technology, Government of India.
                        </div>
                    </div>
                    <div className='flex justify-end items-end'>
                        {/* <h1 className='p-3 font-bold font-mono text-center'>To bring inspiration and innovation to every business in the world.</h1> */}
                        {/* <div className='m-3'>
                        </div> */}
                        <div className=''>
                            <img src={aim} alt="aim" className='flex justify-center items-end' />
                        </div>
                    </div>

                    {/* <div className='absolute bg-black blur-2xl z-20'></div> */}
                </div>
                <div>
                    <div className='w-full flex grid lg:grid-cols-2 md:grid-cols-1 justify-start '>
                        {/* <div className=''></div> */}

                        {/* <div>
                                <h1 className='p-3 font-bold font-mono text-center'>To bring inspiration and innovation to every business in the world.</h1>
                            </div> */}
                        <div className='lg-h[200px] flex justify-center '>
                            <img src={atma2} alt="" className='' />
                        </div>

                        <div className='font-montserrat  text-start text-center flex grid grid-cols-1 justify-center '>
                            <h1 className='text-black lg:text-center text-5xl animate-up flex font-bold justify-center lg:items-end sm:items-start'><span className='text-6xl text-blue-600 '>V</span>ision</h1>
                            <div className='lg:text-xl sm:m-10 sm:p-10  p-10'>
                                In order to make India globally competitive and to fulfil the vision of building a self-reliant
                                India, start-ups and innovators play a vital role. The Atma Nirbhar Bharat Abhiyan is a
                                chance for Indian start-ups to take charge of the innovations for which we are usually
                                dependent on global suppliers. Our startups are contributing to the mission by innovating and
                                bringing to market, products and services that are world-class yet affordable. They are quick
                                to spot opportunities in adversity and innovate within their limited time and budget to make
                                competitive products.
                            </div>
                        </div>

                    </div>
                </div>
                {/* <div className=" flex items-center justify-center bg-fixed bg-center bg-cover " style={{ backgroundImage: `url(${para1})`, height: '40vh', padding: '10px' }}>
                </div> */}
                {/* <div className='lg:p-10 sm:p-5 flex flex-row'>
                    <div className=' flex justify-center '>
                        <img src={mission} alt="" className='rounded-xl' />
                    </div>
                    <div className='font-montserrat  text-start text-center flex grid grid-cols-1 justify-center p-2'>
                        <h1 className='text-5xl text-blue-400 font-bold font-mono text-center'>Mission</h1>
                        <p className='lg:text-xl sm:m-10 sm:p-10 lg:p-10'>To catalyze the growth of a vibrant startup ecosystem by empowering entrepreneurs, startups, and researchers
                            with access to advanced technologies, expert mentorship, and strategic funding. TBIF is dedicated to nurturing
                            deep tech innovations in key areas such as manufacturing, defense, IoT, AI, and healthcare, with the goal of
                            driving economic growth, technological advancement, and societal impact at both regional and national levels.
                        </p>
                    </div>
                </div> */}
                <div className='w-full flex grid lg:grid-cols-2 md:grid-cols-1  p-5'>
                    <div className='lg-h[200px]  flex justify-center'>
                        <img src={mission} alt="" className=' rounded-3xl' style={{maxHeight:'500px'}} />
                    </div>
                    <div className='font-montserrat text-center flex grid grid-cols-1 flex justify-center items-center'>
                        <h1 className=' text-start text-5xl animate-up flex text-black justify-center items-end sm: '> <span className='text-7xl font-bold text-blue-600'>O</span>ur Mission </h1>
                        <h3 className='lg:text-xl  sm:p-10 text-start'>
                            To catalyze the growth of a vibrant startup ecosystem by empowering entrepreneurs, startups, and researchers
                            with access to advanced technologies, expert mentorship, and strategic funding. IIT Ropar TBIF is dedicated to nurturing
                            deep tech innovations in key areas such as manufacturing, defense, IoT, AI, and healthcare, with the goal of
                            driving economic growth, technological advancement, and societal impact at both regional and national levels.
                        </h3>
                    </div>

                    {/* </div> */}
                </div>
                {/* <div className='sm:hidden lg:visible'> */}
                <div className='w-full flex grid lg:grid-cols-2 md:grid-cols-1  p-5'>
                    <div className='font-montserrat text-center flex grid grid-cols-1'>
                        <h1 className='text-orange-400 text-start text-5xl animate-up flex justify-center lg:items-end sm:items-start'> </h1>
                        <h3 className='lg:text-xl  sm:p-10 text-start'>
                            {/* At present, we have a total of thirty one active incubated startups, with several more in the pipeline. */}
                            Our startups are working on products like developing True AI and Smart IP Cameras, and NVRs with
                            state-of-the-art Hardware and Software systems, flexible heat patches, Gyro Chassis for T90 tanks Gun,
                            SIFCON Panels for Baffle ranges, neonatal anti-sore beds, ICU Isolation Bed, health kiosk, drones,
                            sustainable construction materials, textile chemical solutions, AI-based platform for recruitment,
                            Hydrogen Dispensing Stations, robotic arms, Solar Powered Waste Plastic Pyrolysis System, etc.
                        </h3>
                    </div>
                    <div className='lg-h[200px] flex justify-center py-20'>
                        <img src={atma} alt="" className='' />
                    </div>
                    {/* </div> */}
                </div>
            </div>
        </div >
    );
};

export default About;